import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { AllPlansInclude } from './components/AllPlansInclude';
import { ComparisonTable } from './components/ComparisonTable';
import { Portfolio } from './components/Portfolio';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { WhatsAppButton } from './components/WhatsAppButton';
import { useScreenInit } from './useScreenInit.js';
type View = 'home' | 'privacy' | 'terms';
export function App() {
  const init = useScreenInit() as {
    view?: View;
  };
  const [view, setView] = useState<View>(init.view || 'home');
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as View;
      if (detail === 'home' || detail === 'privacy' || detail === 'terms') {
        setView(detail);
        window.scrollTo(0, 0);
      }
    };
    window.addEventListener('nova-navigate', handler);
    return () => window.removeEventListener('nova-navigate', handler);
  }, []);
  return <div className="min-h-screen bg-nova-bg text-nova-text font-poppins selection:bg-nova-accent selection:text-nova-bg relative" data-id="element-0">
      {/* Global SVG filter — removes white background from logo PNGs by mapping luminance to alpha */}
      <svg width="0" height="0" style={{
      position: 'absolute'
    }} aria-hidden="true" data-id="element-1">
        <defs data-id="element-2">
          <filter id="novaweb-drop-white" colorInterpolationFilters="sRGB" data-id="element-3">
            <feColorMatrix type="matrix" values="
              1 0 0 0 0
              0 1 0 0 0
              0 0 1 0 0
              -0.5 -0.5 -0.5 0 1.5" data-id="element-4" />
          </filter>
        </defs>
      </svg>

      {/* Global Background Elements */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-5">
        {/* Top Right Glow */}
        <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] bg-nova-accent/10 rounded-full blur-[120px]" data-id="element-6" />

        {/* Grid Lines */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-7" />

        {/* Dots Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-8" />
      </div>

      <div className="relative z-10" data-id="element-9">
        <Navbar data-id="element-10" />
        {view === 'home' && <>
            <main data-id="element-11">
              <Hero data-id="element-12" />
              <Problem data-id="element-13" />
              <HowItWorks data-id="element-14" />
              <About data-id="element-15" />
              <Portfolio data-id="element-16" />
              <Testimonials data-id="element-17" />
              <Pricing data-id="element-18" />
              <AllPlansInclude data-id="element-19" />
              <ComparisonTable data-id="element-20" />
              <FAQ data-id="element-21" />
              <FinalCTA data-id="element-22" />
              <Contact data-id="element-23" />
            </main>
            <Footer data-id="element-24" />
          </>}
        {view === 'privacy' && <>
            <PrivacyPolicy data-id="element-25" />
            <Footer data-id="element-26" />
          </>}
        {view === 'terms' && <>
            <TermsOfService data-id="element-27" />
            <Footer data-id="element-28" />
          </>}
      </div>

      {/* Floating WhatsApp Button — visible on all views */}
      <WhatsAppButton data-id="element-29" />
    </div>;
}